module.exports = __webpack_public_path__ + "static/img/home_active.e27fc6ac.png";